import { connect } from "react-redux";
import actionCreators from "../redux/actionCreators";
import api from "../redux/api";
import { getActionLogEventTypeDictionary, getActionLogProjects, getActionLogUsers } from "../redux/selectors";
import ActionGrid from "./actionGrid";
const mapStateToProps = (state) => ({
    actionLogEventTypeDictionary: getActionLogEventTypeDictionary(state),
    actionLogProjects: getActionLogProjects(state),
    actionLogUsers: getActionLogUsers(state),
    loadUrl: api.getActionLogs
});
const mapDispatchToProps = (dispatch) => ({
    onInitialized: () => {
        dispatch(actionCreators.getActionLogUsers());
        dispatch(actionCreators.getActionLogProjects());
        dispatch(actionCreators.getActionLogEventTypeDictionary());
    }
});
export default connect(mapStateToProps, mapDispatchToProps)(ActionGrid);
